"use client"

import { ampli } from "@/ampli"
import { decodeGraphqlNodeId } from "@/tracking"
import type { NovaSession } from "@/types"
import { useCallback, useEffect, useState } from "react"

export const ScreenTrack: React.FC<{
  creativeId: string | undefined | null
  serverSession: NovaSession | null
}> = ({ creativeId, serverSession }) => {
  const [tracked, setTracked] = useState(false)

  const accountType = serverSession?.account
  const ampliLoaded = ampli.isLoaded

  const isMyProfile = serverSession?.user?.creative?.id === creativeId

  const handleViewProfile = useCallback(() => {
    if (!isMyProfile && creativeId) {
      fetch("/api/view/profile", {
        method: "POST",
        body: JSON.stringify({ id: creativeId }),
      })
    }
  }, [isMyProfile, creativeId])

  useEffect(() => {
    handleViewProfile()
    if (creativeId && !tracked && ampliLoaded && accountType && !isMyProfile) {
      ampli.profileView({
        creative_id: decodeGraphqlNodeId(creativeId).numericalId || "",
        account_type: accountType || "",
      })
      setTracked(true)
    }
  }, [creativeId, tracked, ampliLoaded, accountType, isMyProfile, handleViewProfile])

  return null
}
